"use client";
import React, { useEffect, useRef, useState } from "react";
import { Autocomplete, AutocompleteItem } from "@nextui-org/react";
import { useAsyncList } from "@react-stately/data";
import { SearchIcon } from "../molecules/SearchIcon";
import { baseUrl, flattenAttributes, getLink } from "../../lib/util";
import endpoints from "../../lib/endpoints";
import { useParams, useRouter } from "next/navigation";
import { useDictionary } from "../../context/dictionaryProvider";
import { debounce } from "../../lib/util";

export default function BlogAutocomplete({ baseClass }) {
  const dict = useDictionary();
  const params = useParams();
  const router = useRouter();
  const hasReloaded = useRef(false);
  const [inputFocused, setInputFocused] = useState(false);

  let list = useAsyncList({
    async load({ signal, filterText }) {
      if (!inputFocused) return { items: [] };
      let res = await fetch(
        `${baseUrl}${endpoints.getSingleBlog}?filters[title][$contains]=${filterText}&locale=${params.lang}`,
        { signal }
      );
      let json = await res.json();
      return {
        items: flattenAttributes(json.data),
      };
    },
  });

  const handleFocus = () => {
    setInputFocused(true);
  };

  useEffect(() => {
    if (inputFocused && !hasReloaded.current) {
      list.reload();
      hasReloaded.current = true; // Prevent subsequent reloads
    }
  }, [inputFocused, list]);

  const handleChange = (key) => {
    if (key) router.push(key);
  };

  return (
    <Autocomplete
      className="w-full rounded-full"
      inputValue={list.filterText}
      isLoading={list.isLoading}
      items={list.items}
      aria-label={dict?.blog?.search}
      placeholder={dict?.blog?.search}
      variant="bordered"
      onInputChange={(value) => debounce(list.setFilterText(value), 2000)}
      onFocus={handleFocus}
      startContent={<SearchIcon />}
      clearIcon={null}
      classNames={{
        base: `${baseClass ? baseClass : ""} searchGroup blogSearchGroup`,
        inputWrapper: "searchInput",
        mainWrapper: "inputGroup",
        clearButton: "hidden",
        endContentWrapper: "hidden",
      }}
      endContent={null}
      size="lg"
      inputProps={{
        classNames: {
          inputWrapper: "rounded-full",
          base: "",
        },
      }}
      onSelectionChange={handleChange}
    >
      {(item) => (
        <AutocompleteItem
          key={getLink(`/${params.lang}/blog/${item?.slug}`)}
          className="capitalize"
        >
          {item.title}
        </AutocompleteItem>
      )}
    </Autocomplete>
  );
}
